import { Prisma } from "db"

export const imageSelectVX = Prisma.validator<Prisma.ImageArgs>()({
  select: {
    accentColor: true,
    height: true,
    translations: { orderBy: { locale: "asc" }, select: { alternateText: true, locale: true } },
    url: true,
    variants: { select: { url: true, width: true } },
    width: true,
  },
})
